import { ActionReducer, createReducer, on } from '@ngrx/store';

import {
  addMailingReportItem,
  deleteMailingReportItem,
  loadMailingReportsList,
  loadMailingReportsListFailure,
  loadMailingReportsListSuccess,
  setLastPageStateMailingReports,
  updateMailingReportItem,
} from '@store/mailingReports/mailingReports.actions';
import {
  initialStateMailingReports,
  mailingReportsAdapter,
  MailingReportsState,
} from '@store/mailingReports/mailingReports.state';

export const mailingReportsReducer: ActionReducer<MailingReportsState> = createReducer(
  initialStateMailingReports,
  on(loadMailingReportsList, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadMailingReportsListSuccess, (state, { list }) =>
    mailingReportsAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadMailingReportsListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addMailingReportItem, (state, { item }) => mailingReportsAdapter.addOne(item, state)),
  on(updateMailingReportItem, (state, { id, changes }) =>
    mailingReportsAdapter.updateOne({ id: +id, changes }, state),
  ),
  on(deleteMailingReportItem, (state, { id }) => mailingReportsAdapter.removeOne(+id, state)),

  on(setLastPageStateMailingReports, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),
);
